var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSplash = function SvgSplash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M128 64c-12.425-5.475-16.599-21.042-8.577-32C105.926 33.476 94.524 22.074 96 8.577 85.042 16.607 69.475 12.433 64 0c-5.475 12.426-21.042 16.6-32 8.577C33.476 22.082 22.074 33.476 8.577 32 16.607 42.958 12.433 58.525 0 64c12.433 5.475 16.6 21.042 8.577 32 13.505-1.476 24.899 9.926 23.423 23.423 10.958-8.03 26.525-3.856 32 8.577 5.475-12.433 21.042-16.599 32-8.577-1.476-13.505 9.926-24.899 23.423-23.423-8.03-10.958-3.856-26.525 8.577-32"
  })));
};
export default SvgSplash;